// extracted by mini-css-extract-plugin
export default {"goal":"GoalItem_goal__Brrkk","date":"GoalItem_date__6-tCj","text":"GoalItem_text__WCGR-","close":"GoalItem_close__kuzs6","editBtn":"GoalItem_editBtn__zmUaG"};